<template>
  <div class="crib-model">
    <div class="crib-model-wrapper" ref="cribWrapper" id="crib-model-wrapper">
      <div class="model-loading" v-show="loading">
        <div class="loading-title">正在加载中，请稍后···</div>
      </div>
      <div @click.stop="selectCrib(data.siteId)" class="crib-name-list" v-show="!loading" :class="[data.sign === 1 ? 'crib-name-list-active' : 'crib-name-list-lost', data.flagPlan ? '' : 'crib-name-list-false']" v-for="(data, index) in cribNameList" :id="data.id" :key="index + 'cribNameList'">
        <div class="crib-name-wrapper">{{data.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three/build/three.module.js'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import $ from 'jquery'
import { searchStackList } from '../../../api/maintain'
var multiple = 100
var container
var camera, scene, renderer, controls, group, pointLight
var raycaster = new THREE.Raycaster()
var mouse = new THREE.Vector2()
var fov = 15 // 拍摄距离
var near = 1// 最小范围
var far = 50 * multiple// 最大范围
export default {
  name: 'CribModel',
  props: ['layerId', 'pidRoute'],
  data () {
    return {
      loading: false,
      threeWidth: '',
      threeHeight: '',
      percentage: 0,
      cribNameList: [],
      siteId: '',
      siteType: ''
    }
  },
  watch: {
    layerId: function (val) {
      if (group) {
        this.siteId = val
        this.siteType = '03'
        this.loadCribModel()
      }
    },
    pidRoute: function (data) {},
    siteId: function () {
      let data = {
        siteId: this.siteId,
        siteType: this.siteType
      }
      this.$emit('getSiteId', data)
    }
  },
  mounted () {
    this.threeWidth = this.$refs.cribWrapper.clientWidth
    this.threeHeight = this.$refs.cribWrapper.clientHeight
    fov = 1632 * fov / this.threeWidth
    this.init()
    this.animate()
  },
  methods: {
    init () {
      const that = this
      container = document.getElementById('crib-model-wrapper')

      // camera
      camera = new THREE.PerspectiveCamera(fov, that.threeWidth / that.threeHeight, near, far)
      camera.position.x = 0
      camera.position.y = 1.2 * multiple
      camera.position.z = 1 * multiple

      // scene
      scene = new THREE.Scene()

      pointLight = new THREE.PointLight('#fff', 0.5)
      pointLight.position.set(0, fov, 0)
      scene.add(pointLight)

      // var light = new THREE.PointLight(0xffffff, 1.2, 2000)
      // light.position.set(0, 30, 0)
      // light.castShadow = true
      // light.shadow.mapSize.width = 1024
      // light.shadow.mapSize.height = 1024
      // scene.add(light)
      var HemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1)
      scene.add(HemisphereLight)
      scene.add(camera)

      // renderer
      renderer = new THREE.WebGLRenderer({antialias: true, alpha: true})
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(that.threeWidth, that.threeHeight)
      renderer.setClearAlpha(0)

      // controls
      controls = new OrbitControls(camera, renderer.domElement)
      controls.maxPolarAngle = Math.PI * 0.5
      controls.minDistance = 1
      controls.maxDistance = 3 * multiple
      // controls.maxAzimuthAngle = 0
      // controls.minAzimuthAngle = 0
      this.siteId = this.layerId
      this.siteType = '03'
      this.loadCribModel()
      container.appendChild(renderer.domElement)
      if (document.getElementById('crib-model-wrapper')) {
        document.getElementById('crib-model-wrapper').addEventListener('click', this.onDocumentMouseClick, false)
        window.addEventListener('resize', this.onWindowResize, false)
      }
    },
    onWindowResize () {
      if (this.$refs.cribWrapper) {
        this.threeWidth = this.$refs.cribWrapper.clientWidth
        this.threeHeight = this.$refs.cribWrapper.clientHeight
        camera.aspect = this.threeWidth / this.threeHeight
        camera.updateProjectionMatrix()
        renderer.setSize(this.threeWidth, this.threeHeight)
      }
    },
    onDocumentMouseClick (event) {
      event.preventDefault()
      this.cribNameList.map(data => {
        data.sign = 0
      })
      this.siteId = this.layerId
      this.siteType = '03'
    },
    getIntersects (x, y) {
      x = (x / this.threeWidth) * 2 - 1
      y = -(y / this.threeHeight) * 2 + 1
      mouse.set(x, y, 0.5)
      raycaster.setFromCamera(mouse, camera)
      return raycaster.intersectObject(group, true)
    },
    animate () {
      requestAnimationFrame(this.animate)
      if (this.cribNameList.length > 0) {
        this.renderDiv(this.cribNameList)
      }
      this.render()
    },
    render () {
      renderer.render(scene, camera)
    },
    loadCribModel: function () {
      let body = {
        pidRoute: this.pidRoute
      }
      scene.remove(group)
      controls.reset()
      camera.updateProjectionMatrix()

      // group
      group = new THREE.Group()
      scene.add(group)
      const that = this
      this.loading = true
      searchStackList(body).then(res => {
        console.log(res)
        // 加载 glTF 格式的模型
        var loader = new GLTFLoader().setPath('static/models/gltf/')
        loader.load(this.layerId + '.glb', function (object) {
          // console.log(object.scene.children)
          // add sprites
          group.add(object.scene)
          that.cribNameList = []
          object.scene.children.map((data, index) => {
            if (index !== 0) {
              res.data.map(item => {
                if (item.id.toString() === data.name) {
                  that.cribNameList.push({
                    id: 'crib' + index,
                    name: item.nameCn,
                    flagPlan: item.flagPlan,
                    position: {
                      x: data.position.x,
                      y: data.position.y,
                      z: data.position.z
                    },
                    siteId: data.name,
                    sign: 0
                  })
                }
              })
            }
          })
          that.loading = false
        }, function (xhr) {
          if (xhr.lengthComputable) {
            var percentComplete = (xhr.loaded / xhr.total * 100)
            console.log(Math.round(percentComplete, 2))
            setTimeout(function () {
              that.percentage = Math.round(percentComplete, 2)
            }, 0)
          }
        }, function () {
          console.log('load error!')
          that.$message({
            message: '模型加载失败！',
            type: 'warning',
            center: 'true',
            duration: '2000'
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    renderDiv (cribNameList) {
      if (cribNameList.length > 0) {
        // 获取窗口的一半高度和宽度
        var halfWidth = this.threeWidth / 2
        var halfHeight = this.threeHeight / 2
        cribNameList.map(data => {
          // 逆转相机求出二维坐标
          var vec3 = new THREE.Vector3(data.position.x, 2, data.position.z)
          var posi = vec3.project(camera)

          // 修改 div 的位置
          $('#' + data.id).css({
            left: posi.x * halfWidth + halfWidth,
            top: -posi.y * halfHeight + halfHeight
          })
        })
      }
    },
    selectCrib: function (siteId) {
      this.cribNameList.map(data => {
        data.sign = 0
        if (data.siteId === siteId) {
          data.sign = 1
          this.siteId = parseInt(data.siteId)
          this.siteType = '05'
          this.$emit('getCribInfo', data.siteId, data.name)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .crib-model {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .crib-model-wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      .crib-name-list {
        position: absolute;
        .crib-name-wrapper {
          transition: all ease-in 100ms;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
          font-size: 0.63vw;
          background-color: rgba(16, 20, 49, 0.9);
          padding: 0.5vw 0.3vw;
          border: 0.05vw solid #0c71e8;
          border-radius: 0.1vw;
          color: #00d2ff;
          cursor: pointer;
        }
        .crib-name-wrapper:hover {
          color: #00d2ff;
          background-color: rgba(16, 20, 49, 1);
        }
      }
      .crib-name-list:hover {
        z-index: 11;
      }
      .crib-name-list-active {
        z-index: 10;
        .crib-name-wrapper {
          color: #00d2ff;
          background-color: rgba(16, 20, 49, 1);
        }
      }
      .crib-name-list-lost {
        z-index: 9;
      }
      .crib-name-list-false {
        .crib-name-wrapper {
          color: #fff;
          background-color: rgba(16, 20, 49, 0.6);
        }
        .crib-name-wrapper:hover {
          color: #00d2ff;
          background-color: rgba(16, 20, 49, 0.9);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/maintain/main/CribModel.vue